import {FC} from "react"
import {Block} from "./Block"
import {CoursePageProps} from "./CoursePageProps"

export const GuiltAndRegret: FC<Pick<CoursePageProps, "course">> = () => {
  return (
    <>
      <Block>
        <h1 className="mt-16">Reducing Guilt and Regret</h1>
        <p>The main goal of the program is to transform guilt, especially its non-adaptive
          part - neurotic guilt, into healthy manifestations.
        </p>

        <h1 className="mt-16">The goals of the program:</h1>
        <p>Real guilt will be transformed into remorse, which does not freeze
          in unpleasant feelings but frees and provides energy for action.
        </p>

        <p>Neurotic guilt (personal, transgenerational, group, guilt towards the deceased),
          guilt that has no real basis and arises as a result of dysfunctional upbringing,
          will be dissolved or provided with meditations for further self-work.
        </p>

        <p>Empathic guilt will be transformed into compassion without personal pain.</p>

        <p>To achieve these goals, the following activities will be conducted:</p>
        <ul className="list-rhombus">
          <li>Theoretical part, where the psychological mechanism of guilt and
            its various forms will be examined.
          </li>
          <li>Working on awareness of the sources of guilt and considering how
            they can affect one&apos;s life.
          </li>
          <li>Working on forgiveness techniques, both for oneself and for others.</li>
          <li>Meditations that help to get rid of negative emotions associated
            with guilt and regret.
          </li>
          <li>Mindfulness exercises to learn how to take responsibility for
            one&apos;s actions and not burden oneself with excessive guilt.
          </li>
          <li>Working on strengthening self-esteem and developing
            a healthy relationship with oneself and one&apos;s actions.
          </li>
        </ul>
      </Block>

      <Block>
        <p>
          Throughout the program, special attention will be given to the root causes underlying
          guilt and regret, and participants will be helped to find ways to overcome these problems.
          The program aims to help transform negative emotions into positive energy for
          a better life.
        </p>
      </Block>
    </>
  )
}
